import { Col, Row } from "antd";
import React from "react";

const Container = ({ children, className, containerStyle, ...props }) => (
  <Row style={containerStyle}>
    <Col xs={1} md={5} xl={7} />
    <Col
      xs={22}
      md={14}
      xl={10}
      children={children}
      className={`m-20-v ${className}`}
      {...props}
    />
    <Col xs={1} md={5} xl={7} />
  </Row>
);

export default Container;
